export default {
  unauthorizedAdmin: [
    {
      path: 'login',
      name: 'admin.login',
      component: () => import('modules/user/views/unauthorizedAdmin/login.vue'),
    },
    {
      path: 'forgot-password',
      name: 'admin.forgot-password',
      component: () => import('modules/user/views/unauthorizedAdmin/forgotPassword.vue'),
    },
  ],
  admin: [
    // account
    {
      path: 'account',
      name: 'admin.account.profile',
      component: () => import('modules/user/views/admin/profile.vue'),
    },
    {
      path: 'account/reset-password',
      name: 'admin.account.reset-password',
      component: () => import('modules/user/views/admin/resetPassword.vue'),
      meta: {
        mode: 'update',
      },
    },

    // 管理員
    {
      path: 'user',
      name: 'admin.user-list',
      component: () => import('modules/user/views/admin/userList.vue'),
    },
    {
      path: 'user/create',
      name: 'admin.user-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/user/views/admin/userForm.vue'),
    },
    {
      path: 'user/update/:id',
      name: 'admin.user-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/user/views/admin/userForm.vue'),
    },
    {
      path: 'user/password/:id',
      name: 'admin.user-update-password',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/user/views/admin/userUpdatePassword.vue'),
    },
    {
      path: 'config/user',
      name: 'admin.config.user',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/user/views/admin/userConfigForm.vue'),
    },

    // 管理員群組
    {
      path: 'user-group',
      name: 'admin.user-group-list',
      component: () => import('modules/user/views/admin/userGroupList.vue'),
    },
    {
      path: 'user-group/create',
      name: 'admin.user-group-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/user/views/admin/userGroupForm.vue'),
    },
    {
      path: 'user-group/update/:id',
      name: 'admin.user-group-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/user/views/admin/userGroupForm.vue'),
    },

    // // 操作紀錄頁
    // {
    //   path: 'operate-record',
    //   name: 'admin.operate-record-list',
    //   component: () => import('modules/user/views/admin/operateRecordList.vue'),
    // },

    // // 密碼變更頁
    // {
    //   path: 'reset-password-record',
    //   name: 'admin.reset-password-record-list',
    //   component: () => import('modules/user/views/admin/resetPasswordRecordList.vue'),
    // },

    // 操作紀錄頁
    {
      path: 'operate-record',
      name: 'page.operateRecord',
      component: () => import('modules/user/views/admin/records.vue'),
    },

    // 登入紀錄頁
    {
      path: 'login-record',
      name: 'page.loginRecord',
      component: () => import('modules/user/views/admin/loginRecordList.vue'),
    },
  ],
}